import { createMutationAtom } from 'atoms/create-resource-atom';
import { useSetAtom } from 'jotai';

export interface UpdateStateTaxPayload {
  oil_tax_percentage: number;
  gas_tax_percentage: number;
  ngl_tax_percentage: number;
  ad_valorem_tax_percentage: number;
}

export const updateStateTaxAtom = createMutationAtom<null, 'stateTaxes'>();

export function useUpdateStateTax() {
  const mutate = useSetAtom(updateStateTaxAtom);
  return (
    stateTaxId: string,
    payload: UpdateStateTaxPayload,
    onSaved: () => void,
    setUpdateFailedError: (error: boolean) => void
  ) => {
    return mutate({
      url: `/state_taxes/${stateTaxId}`,
      type: 'PATCH',
      data: payload,
      onSuccess: () => {
        onSaved();
        setUpdateFailedError(false);
      },
      onError: () => {
        setUpdateFailedError(true);
      },
    });
  };
}
